import type React from 'react';
import { Outlet } from 'react-router-dom';

export const PublicRoutes: React.FC = () => {
    return <Outlet />;
};
